let isMobile = function () {
  const userAgent = navigator.userAgent.toLowerCase();
  const isIpad = userAgent.match(/ipad/i) != null;
  const isIphoneOs = userAgent.match(/iphone/i) != null;
  const isUc7 = userAgent.match(/rv:1.2.3.4/i) != null;
  const isUc = userAgent.match(/ucweb/i) != null;
  const isAndroid = userAgent.match(/android/i) != null;
  const isCe = userAgent.match(/windows ce/i) != null;
  const isWm = userAgent.match(/windows mobile/i) != null;
  return isIpad || isIphoneOs || isUc7 || isUc || isAndroid || isCe || isWm;
};

export default isMobile;
